import { HttpStatusCode } from 'axios';

import { ErrorMessage } from '@/core/constants/ErrorMessage';
import MessageHelper from '@/core/helpers/MessageHelper';
import NumberHelper from '@/core/helpers/NumberHelper';
import { Result } from '@/core/models/Result';

export default class FormatPriceViewModel {
    price: number = 0;
    defaultText: string = '';

    public constructor(price: any) {
        if (price && NumberHelper.isValid(price)) {
            this.price = price;
        }
    }

    public validate(): Result<any> {
        let result = new Result<any>();

        if (NumberHelper.isValid(this.price) === false) {
            result.message = MessageHelper.format(ErrorMessage.INVALID_PARAMETER, 'price');
            result.responseCode = HttpStatusCode.BadRequest;
            return result;
        }

        result.success = true;
        return result;
    }
}
